module.exports = __webpack_public_path__ + "static/kiosk-75e5f0b1ef9c4dc91fa99a4afe70f02e.png";